export default __webpack_public_path__ + "locales/si/PortalUnavailable.json?hash=9a43058da3510f9d8cedf9231dc1d1d2";